import React, { FunctionComponent } from 'react';
import HowItWorks from '@/components/GreenCards/Common/HowItWorks/HowItWorks';
import SeoFooter from '@/components/GreenCards/Common/SeoFooter/SeoFooter';
import SuccessRate from '@/components/GreenCards/Common/SuccessRate/SuccessRate';
import VisalexFeatures from '@/components/GreenCards/Common/VisalexFeatures/VisalexFeatures';
import IntroducingVisalex from '@/components/IntroducingVisalex/IntroducingVisalex';
import { Layout } from '@/components/Layout';
import { createArrayInRange, Hero, LinkButton } from '@visalex/core';

import cx from 'clsx';
import { Trans, useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

import styles from './EmploymentBased.module.scss';
import commonStyles from '@/components/GreenCards/Common/GreenCardLanding.module.scss';

const prefix = 'employment-based';

const EmploymentBased: FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <Layout title={t(`${prefix}.seo-title`)} description={t(`${prefix}.seo-description`)}>
      <div className={cx(commonStyles['green-card-landing'], styles[`${prefix}`])}>
        <Hero className={styles[`${prefix}__hero`]}>
          <h1 dangerouslySetInnerHTML={{ __html: t(`${prefix}.hero.title`) }}></h1>
          <p>
            <Trans i18nKey={`${prefix}.hero.for-whom`}>
              Whether you’re a <strong>skilled professional</strong>, <strong>entrepreneur</strong>, or
              <strong> special category immigrant</strong>, or you represent an
              <strong>organization of any size</strong> — VisaLex is here to help. We have the experience and technology
              you need to get your <strong>permanent U.S. residence</strong> permit through employment.
            </Trans>
          </p>
          <LinkButton size="lg" href="/free-consultation">
            {t('nav-bar.schedule-consultation')}
          </LinkButton>
          <small>{t('common.supported-locales')}</small>
        </Hero>
        <IntroducingVisalex i18nPrefix={prefix} />
        <HowItWorks i18nPrefix={prefix} />
        <SuccessRate i18nPrefix={prefix} />
        <VisalexFeatures i18nPrefix={prefix} featureIds={createArrayInRange(0, 9)} />
        <SeoFooter i18nPrefix={prefix} />
      </div>
    </Layout>
  );
};

export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await serverSideTranslations(locale)),
    },
  };
}
export default EmploymentBased;
